// Spanish for the pay area (My Pay, Sub Pay, history, linked jobs, header,
// sign in). English text (exact) -> Spanish.
const dict = {
  // ---- App header / loading ----
  "Loading...": "Cargando...",
  "Could not load your account. Check your connection.": "No se pudo cargar su cuenta. Revise su conexión.",
  "Try again": "Intentar de nuevo",
  "Welcome to Your Servicing HQ Portal": "Bienvenido a su Portal de Servicing HQ",
  "Sign Out": "Cerrar Sesión",

  // ---- Sign in / forgot password ----
  "Sign In": "Iniciar Sesión",
  "Email": "Correo electrónico",
  "Password": "Contraseña",
  "Invalid email or password. Please try again.": "Correo o contraseña incorrectos. Intente de nuevo.",
  "Forgot password?": "¿Olvidó su contraseña?",
  "Reset Password": "Restablecer Contraseña",
  "Enter the email you sign in with. We'll email you a link to set a new password.":
    "Escriba el correo con el que inicia sesión. Le enviaremos un enlace para crear una contraseña nueva.",
  "Enter your email address.": "Escriba su correo electrónico.",
  "Sending…": "Enviando…",
  "Send reset link": "Enviar enlace",
  "If an account exists for that email, a reset link has been sent. Check your inbox and spam folder.":
    "Si existe una cuenta con ese correo, se envió un enlace para restablecer la contraseña. Revise su bandeja de entrada y la carpeta de spam.",
  "That email address doesn't look right. Check it and try again.":
    "Ese correo no parece correcto. Revíselo e intente de nuevo.",
  "No connection. Check your signal and try again.": "Sin conexión. Revise su señal e intente de nuevo.",
  "Too many tries. Wait a few minutes and try again.": "Demasiados intentos. Espere unos minutos e intente de nuevo.",
  "The reset link could not be sent. Try again.": "No se pudo enviar el enlace. Intente de nuevo.",
  "Back to sign in": "Volver a iniciar sesión",

  // ---- My Pay (sub contractors) ----
  "My Pay": "Mi Pago",
  "Earned": "Ganado",
  "Paid": "Pagado",
  "Owed to you": "Se le debe",
  "Refresh": "Actualizar",
  "Loading…": "Cargando…",
  "Paid to you": "Pagado a usted",
  "Still owed to you": "Todavía se le debe",
  "{amount} of your payments weren't tied to one job. They count toward your total.":
    "{amount} de sus pagos no están ligados a un trabajo. Cuentan para su total.",
  "My jobs": "Mis trabajos",
  "Only jobs with a balance": "Solo trabajos con saldo",
  "Date": "Fecha",
  "WO / Site": "OT / Sitio",
  "Pay": "Pago",
  "Balance": "Saldo",
  "Visit": "Visita",
  "No jobs with pay yet.": "Todavía no hay trabajos con pago.",
  "Payments": "Pagos",
  "Amount": "Monto",
  "How": "Forma de pago",
  "Check # / Ref": "Cheque # / Ref.",
  "For": "Para",
  "No payments yet.": "Todavía no hay pagos.",
  "Questions about a payment? Contact the office. Amounts update when the office records a payment.":
    "¿Preguntas sobre un pago? Comuníquese con la oficina. Los montos se actualizan cuando la oficina registra un pago.",
  "Your pay could not load. Check your connection and try again.":
    "No se pudo cargar su pago. Revise su conexión e intente de nuevo.",
  "General (not tied to a job)": "General (no ligado a un trabajo)",

  // Payment methods (display only; stored values stay English)
  "Check": "Cheque",
  "ACH": "ACH",
  "Cash": "Efectivo",
  "Zelle": "Zelle",
  "Credit Card": "Tarjeta de crédito",
  "Other": "Otro",

  // ---- Sub Pay on a job (sub's own view) ----
  "My pay on this job": "Mi pago en este trabajo",
  "Owed": "Se debe",
  "Directions": "Instrucciones",
  "Note": "Nota",
  "Saving…": "Guardando…",
  "Sub pay could not load. Check your connection and try again.":
    "No se pudo cargar el pago del subcontratista. Revise su conexión e intente de nuevo.",
  "No sub contractors on this job yet. Add one under Tech Assign (Edit), then pick Daily or Project.":
    "Todavía no hay subcontratistas en este trabajo. Agregue uno en Técnicos Asignados (Editar) y elija Diario o Proyecto.",
  "Project": "Proyecto",
  "Daily": "Diario",
  "Set on back end": "Fijado por la oficina",
  "Owed on this job": "Se debe en este trabajo",
  "incl. change orders {amount}": "incl. órdenes de cambio {amount}",
  "Project price is owed on": "El precio del proyecto se debe en",
  "(first job)": "(primer trabajo)",
  "Project owed": "Se debe del proyecto",
  "Recurring job - use Sub Pay per visit": "Trabajo recurrente - pago por visita",
  "Project price {amount}": "Precio del proyecto {amount}",
  "Project price {amount} (owed on the first job)": "Precio del proyecto {amount} (se debe en el primer trabajo)",
  "{workers} worker(s) × {rate}/day × {days} day(s)": "{workers} trabajador(es) × {rate}/día × {days} día(s)",
  "split with {others} other job(s) on {days} day(s)": "dividido con {others} otro(s) trabajo(s) en {days} día(s)",

  // ---- Job status words (display only) ----
  "Active": "Activo",
  "Completed": "Completado",
  "On Hold": "En Espera",
  "Invoice Sent": "Factura Enviada",
  "Deleted": "Eliminado",

  // ---- Job History popup ----
  "Job History": "Historial del Trabajo",
  "All notes and supervisor notes for WO {wo}": "Todas las notas y notas de supervisor de la OT {wo}",
  ", and any jobs connected to it (Continue / Extend From Existing WO Stem).":
    ", y de los trabajos conectados a ella (Continuar / Extender desde OT existente).",
  "No notes have been added yet.": "Todavía no se han agregado notas.",
  "Supervisor Note": "Nota de Supervisor",
  "File": "Archivo",
  "Close": "Cerrar",

  // ---- Linked jobs ----
  "Jobs Linked": "Trabajos Vinculados",
  "See every job in this chain, first to last": "Ver todos los trabajos de esta cadena, del primero al último",
  "Linked jobs": "Trabajos vinculados",
  "1 job": "1 trabajo",
  "{count} jobs": "{count} trabajos",
  "updates live": "se actualiza en vivo",
  "No other linked jobs yet. When this job is continued (or a stem WO like {wo}-2 is added), it shows up here.":
    "Todavía no hay otros trabajos vinculados. Cuando este trabajo se continúe (o se agregue una OT como {wo}-2), aparecerá aquí.",
  "Open this job": "Abrir este trabajo",
  "This job": "Este trabajo",
  "Not scheduled": "Sin programar",

  // ---- Collapsible sections ----
  "Show": "Mostrar",
  "Hide": "Ocultar",
  "Supervisor": "Supervisor",
};

export default dict;
